import { Record, List } from 'immutable'

const Schedule = Record({
  id:null,
  is_ng:null,
  is_instructor:null,
  comment:null,
  member_name:null,
  member_id:null,
  member_picture:null,
  event_id:null,
  target_date:null,
});
export default Schedule;



// WEBPACK FOOTER //
// ./src/vo/Schedule.js